var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.root, _vm.$style.show]},[_c('div',{class:_vm.$style.overlay,on:{"click":function($event){return _vm.close([null])}}}),_c('div',{class:[_vm.$style.content, _vm.miniMode && _vm.$style.contentMini]},[_c(`Modal${_vm.component}`,{key:_vm.component,tag:"component",attrs:{"value":_vm.value}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }